<template>
  <div class="PresentPersonel">
    <section-search-panel :accessTo="46" @search="search" />
    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div class="vacationList">
        <div v-if="list.length > 0">
          <section-personel-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <section-personel-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list :state="stateList" />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import SectionPersonelListMob from "../../components/personelOperationReport/sectionPersonelList/sectionPersonelListMob.vue";
import SectionPersonelListWeb from "../../components/personelOperationReport/sectionPersonelList/sectionPersonelListWeb.vue";
import SectionSearchPanel from "../../components/personelOperationReport/SectionSearchPanel.vue";
import EmptyList from "../../components/widget/EmptyList.vue";
import ResultType from "../../model/ResultType";
import StateList from "../../model/StateList";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";
export default {
  components: {
    SectionSearchPanel,
    EmptyList,
    SectionPersonelListWeb,
    SectionPersonelListMob,
  },
  data() {
    return {
      list: [],
      searchParams: null,
      stateList: null,
      visiblePrint: false,
      sectionCode: "",
    };
  },
  methods: {
    search(searchParams) {
      debugger
      this.list = [];
      this.stateList = StateList.loading();
      this.sectionCode = searchParams.sectionCode;

      this.searchParams = searchParams;
      var params = searchParams;
      this.$store.dispatch("GetSectionPersons", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.stateList = null;
          this.list = result.data.Table1;
          this.list = this.list.sort((a, b) => a.PERNO >= b.PERNO);
          this.checkVisiblePrint();
        } else {
          this.stateList = StateList.error(result.error);
        }
      });
    },
    onClick(item) {
      debugger
      //console.log(item);
      if (EosUtils.isWebKartAdmin()) {
        //go to personel profile
        var params = {
          pid: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          section: this.searchParams.sectionCode,
        };
        this.$router.push({ name: "personelProfile", query: params });
      } else {
        debugger
        var params2 = {
          pid: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          section: this.searchParams.sectionCode,
          // canchange
          ch:"1",   
         
        };
        debugger
        localStorage.setItem("pidSetPass", params2.pid)
        this.$router.push({ name: "profile", query: params2 });
        // this.$router.push({ name: "personelProfile", query: params2 });
        /*
          if (Sections.CanAccessPersonProfile(PersonnelNo, ddlSections.SelectedItem.Value))
                        Response.Redirect("default.aspx?PID=" + perno + "&SC=" + section);
         */
      }
    },
    checkVisiblePrint() {
      // debugger
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpPersonelsList",
        query: { SC: this.sectionCode },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>

/* tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.1);
} */

</style>